var _rect, _rect2, _circle, _circle2, _rect3, _rect4, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg4468",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 222.4 313",
    style: {
      enableBackground: "new 0 0 222.4 313"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect4500",
    x: 134.4,
    width: 16,
    height: 313
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect4502",
    x: 173.4,
    width: 49,
    height: 313
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 116.7,
    r: 17.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 196.3,
    r: 17.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 150.7,
    width: 222.4,
    height: 11.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 226.1,
    width: 222.4,
    height: 11.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 301.5,
    width: 222.4,
    height: 11.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    y: 75.4,
    width: 222.4,
    height: 11.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 222.4,
    height: 11.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatsign);
export default __webpack_public_path__ + "static/media/Repeatsign.0c80188c735e5aee783158d7f178bb5f.svg";
export { ForwardRef as ReactComponent };